export default __webpack_public_path__ + "static/media/dollar.ede521d2.svg";